///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbNumericInputBaseComponent } from './../numeric-input.base.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'kb-integer-text-box',
    templateUrl: './integer-text-box.component.html',
})
export class KbIntegerTextBoxComponent extends KbNumericInputBaseComponent {
    @ViewChild('integerInput')
    public integerInput: NumericTextBoxComponent;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/integer-text-box/integer-text-box.component.ts